import { useState, useRef, useEffect } from "react";
import { BsCalendarEvent } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "../utils";

export default function CustomDatePicker({ label, placeholder, name, value, onChange, error, disable, isRequired = true }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const inputRef = useRef(null);
  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
      onChange({ target: { name, value: formatDate(date) }});
    }
  };

  const openDatePicker = () => {
    if(inputRef?.current) inputRef.current?.onInputClick();
  }

  useEffect(() => {
    if(value) setSelectedDate(new Date(value));
  }, [value])

  return (
    <div className="input-container">
      {label && <label className="input-label">{label}{isRequired ? <span className="text-danger" style={{fontSize: "14px"}}><sup>*</sup></span> : null}</label>}
      <div className="input-wrapper">
        <DatePicker
        showYearDropdown
        autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          name={name}
          ref={inputRef}
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM-dd"
          disabled={disable}
          className={`w-100 input-box ${error ? "input-error" : ""}`}
          placeholderText={placeholder}
        />
        <span className="input-icon" onClick={openDatePicker}><BsCalendarEvent size={18} /></span>
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}